import React from "react";
import { Avatar, Box, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useSelectedTheme, useTranslate } from "../../../../../Hooks";
import { getDownloadableLink } from "../../../../../Helper";
import {
  CustomBadge,
  CustomCard,
  CustomCopyToClipboard,
} from "../../../../../Components";

// styles
import useStyles from "./styles";

const LeadClassBadges = ({ LeadClasssList }) => {
  const styles = useStyles();

  const { translate } = useTranslate("AfterSalesClientProfileView");
  const {
    theme: { palette },
  } = useSelectedTheme();

  const LeadClasss = [
    {
      id: "1",
      name: translate("seller"),
      backgroundColor: palette.utility.gray_blue_50,
      borderColor: "none",
      color: palette.utility.gray_blue_700,
    },
    {
      id: "2",
      name: translate("landlord"),
      backgroundColor: palette.utility.indigo_50,
      borderColor: "none",
      color: palette.utility.indigo_700,
    },
    {
      id: "3",
      name: translate("buyer"),
      backgroundColor: palette.utility.pink_50,
      borderColor: "none",
      color: palette.utility.pink_700,
    },
    {
      id: "4",
      name: translate("tenant"),
      backgroundColor: palette.utility.blue_50,
      borderColor: "none",
      color: palette.utility.blue_700,
    },
  ];

  return (
    <Box className={styles.badgeSection}>
      {(LeadClasssList.split(",") || []).map((id) => {
        const LeadClass = LeadClasss.find((type) => type.id === id);
        if (!LeadClass) return null;

        return (
          <CustomBadge
            key={id}
            Style={{
              padding: "2px 10px 2px 8px",
              lineHeight: "24px",
              fontSize: "16px",
            }}
            label={LeadClass.name}
            BackgroundColor={LeadClass.backgroundColor}
            BorderColor={LeadClass.borderColor}
            Color={LeadClass.color}
          />
        );
      })}
    </Box>
  );
};

const AssignedAgentCard = ({ items }) => {
  const styles = useStyles();
  const { translate } = useTranslate("AfterSalesClientProfileView");
  const { isDarkMode } = useSelector((state) => state.theme);

  return (
    <>
      {items.map((item) => (
        <CustomCard
          key={item.agentId}
          boxShadow="xs"
          borderRadius="xl"
          borderColor="secondary"
          classes={styles.assignedAgentCard}
        >
          <Box className={styles.upperSection}>
            <Box style={{ visibility: item?.leadClass ? "visible" : "hidden" }}>
              {item?.leadClass && (
                <LeadClassBadges LeadClasssList={String(item.leadClass)} />
              )}
            </Box>
            <Typography className={styles.leadId}>
              {translate("lead-id")}
              <CustomCopyToClipboard
                data={item.leadIds}
                childrenData={"#" + item.leadIds}
                copyDoneShowTime={1000}
                fontSize="14px"
              />
            </Typography>
          </Box>
          <Box className={styles.lowerSection}>
            <Box
              className={styles.avatarWrapper}
              style={isDarkMode ? { backgroundColor: "unset" } : {}}
            >
              <Avatar
                className={
                  item.profileImg ? styles.defaultAvatar : styles.avatar
                }
                src={
                  item?.profileImg
                    ? getDownloadableLink(item.profileImg)
                    : "/images/contacts/MaleAvatar.svg"
                }
              />
            </Box>
            <Typography className={styles.agentName}>
              {item?.agentName}
            </Typography>
          </Box>
        </CustomCard>
      ))}
    </>
  );
};
export default AssignedAgentCard;
